<template>
  <div>
    <v-card flat>
      <v-card-title class="text-h5 font-weight-bold">
        {{ $t('Booking Settings') }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" md="6">
              <v-card outlined class="pa-4 mb-4">
                <v-card-title class="text-subtitle-1 px-0 pt-0">
                  {{ $t('Reservation Settings') }}
                </v-card-title>

                <v-text-field
                  v-model.number="formData.min_ahead"
                  dense
                  outlined
                  type="number"
                  min="0"
                  :rules="[required, minZero]"
                  :label="$t('Minimum Days Ahead')"
                  @input="updateForm"
                />

                <v-switch
                  v-model="formData.show_infants"
                  class="mt-0"
                  size="small"
                  :label="$t('Show infants count picker')"
                  @change="updateForm"
                />
                <v-text-field
                  v-model="formData.default_rate_plan_title"
                  dense
                  outlined
                  :label="$t('Default Rate Plan Title')"
                  @input="updateForm"
                />
              </v-card>

              <v-card outlined class="pa-4">
                <v-card-title class="text-subtitle-1 px-0 pt-0">
                  {{ $t('Payment Settings') }}
                </v-card-title>

                <v-checkbox
                  v-model="formData.allow_bank_payments"
                  :label="$t('Allow bank transfers')"
                  @change="updateForm"
                />

                <v-checkbox
                  v-model="formData.show_fees_breakdown"
                  class="mt-0 mb-6"
                  :label="$t('Show fees breakdown')"
                  :hint="
                    $t(
                      'Display detailed breakdown of fees and taxes on booking page'
                    )
                  "
                  persistent-hint
                  @change="updateForm"
                />

                <div class="d-flex align-center mb-4">
                  <v-checkbox
                    v-model="formData.compare_prices"
                    class="ma-0 pa-0 mr-2"
                    hide-details
                    :label="$t('Compare prices with Airbnb')"
                    @change="updateForm"
                  />
                  <info-tooltip
                    :text="
                      $t(
                        'If enabled, the system will fetch and compare real-time Airbnb prices for the selected dates and show a comparison to your rates.'
                      )
                    "
                  />
                </div>

                <v-text-field
                  v-model.number="formData.custom_markup"
                  dense
                  outlined
                  type="number"
                  min="0"
                  max="100"
                  :rules="[minZero, maxHundred]"
                  :label="$t('Custom Markup (%)')"
                  @input="updateForm"
                />
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card outlined class="pa-4">
                <v-card-title class="text-subtitle-1 px-0 pt-0">
                  {{ $t('Cancellation Policy') }}
                </v-card-title>

                <v-textarea
                  v-model="formData.cancellation_policy"
                  dense
                  outlined
                  :label="$t('Cancellation Policy')"
                  @input="updateForm"
                />
              </v-card>

              <v-card outlined class="pa-4 mt-4">
                <v-card-title class="text-subtitle-1 px-0 pt-0">
                  {{ $t('Custom Terms of Use') }}
                </v-card-title>

                <text-editor
                  v-model="formData.custom_terms_of_use"
                  autofocus
                  :show-save-button="false"
                  @input="updateForm"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import FormRulesMixin from 'components/mixins/form-rules-mixin'
import TextEditor from 'components/common/text-editor'
import InfoTooltip from 'components/common/info-tooltip.vue'

export default {
  name: 'BookingSettings',

  components: {
    TextEditor,
    InfoTooltip,
  },

  mixins: [FormRulesMixin],

  props: {
    bookingEngineSetting: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: {
        min_ahead: this.bookingEngineSetting.min_ahead || 0,
        show_infants: this.bookingEngineSetting.show_infants || false,
        allow_bank_payments:
          this.bookingEngineSetting.allow_bank_payments || false,
        show_fees_breakdown:
          this.bookingEngineSetting.show_fees_breakdown || false,
        compare_prices: this.bookingEngineSetting.compare_prices || false,
        custom_markup: this.bookingEngineSetting.custom_markup || '',
        cancellation_policy:
          this.bookingEngineSetting.cancellation_policy || '',
        custom_terms_of_use:
          this.bookingEngineSetting.custom_terms_of_use || '',
        default_rate_plan_title:
          this.bookingEngineSetting.default_rate_plan_title || '',
      },
    }
  },

  methods: {
    minZero(v) {
      if (!v) return true
      return v >= 0 || 'Must be 0 or greater'
    },

    maxHundred(v) {
      if (!v) return true
      return v <= 100 || 'Must be 100 or less'
    },

    updateForm() {
      if (this.$refs.form.validate()) {
        this.$emit('update:setting', this.formData)
      }
    },

    validate() {
      return this.$refs.form.validate()
    },
  },
}
</script>
